import { SUPPORTED, useI18n } from '../../i18n';

/**
 * Compact language picker bound to the i18n context. Used in the onboarding
 * header (top-right) and the Profile sheet. Native language names are shown.
 */
export function LanguageSelect({ className = '' }: { className?: string }) {
  const { locale, setLocale, t } = useI18n();
  return (
    <select
      aria-label={t('language.aria', 'Select language')}
      value={locale}
      onChange={(e) => setLocale(e.target.value)}
      className={[
        'rounded-full border border-line bg-surface px-3 py-1.5 text-[13px] font-medium text-ink',
        'focus:outline-none focus:ring-2 focus:ring-accent/40',
        className,
      ].join(' ')}
    >
      {SUPPORTED.map((l) => (
        <option key={l.code} value={l.code}>
          {l.label}
        </option>
      ))}
    </select>
  );
}
